import React from 'react'
import { connect } from 'react-redux'
import { NumericFormat } from 'react-number-format'

const NumberInput = (props) => {

    const {
        label,
        specialOnChange,
        input,
        require,
        disabled = false,
        decimalScale = 2,
        fixedDecimalScale = false,
        textAlignLeft,
        thousandSeparator = true,
        allowNegative = true,
        suffix,
        prefix,
        placeholder,
        formatValue = null,
        meta: { touched, error }
    } = props

    return (


        <div className="w-full  px-3 ">
            <label className="block  text-left tracking-wide text-gray-800 font-bold text-sm  mb-2" >
                {label}
                {require ? <span className='ml-2 text-red-500 require'>*</span> : null}
                {touched && error ? <span className='ml-2 text-red-500 require'>{error}</span> : null}
            </label>
            <NumericFormat

                className={` text-base appearance-none outline-none focus:outline-none block w-full 0 text-gray-800 border border-[#FBC558] rounded
                py-3 px-4 mb-3 leading-tight `}
                name={input.name}
                defaultValue={0}
                value={input.value}
                fixedDecimalScale={fixedDecimalScale}
                // thousandSeparator={thousandSeparator}
                decimalScale={decimalScale}
                allowNegative={allowNegative}
                suffix={suffix !== undefined ? suffix : ''}
                prefix={prefix !== undefined ? prefix : ''}
                disabled={disabled}
                placeholder={placeholder}
                format={formatValue}
                onValueChange={values => {
                    input.onChange(values.value)
                    if (specialOnChange) {
                        specialOnChange(values.value)
                    }
                }}
                style={{  textAlign: textAlignLeft ? '' : 'left' ,backgroundColor: disabled ? "#3b3b3b0a" : touched && error ? "#FFF0F0" : "" , borderColor:'#FBC558', opacity:1, lineHeight:'1.2'}}
            />
        </div>




    )
}

const mapStateToProps = (state) => {

    return {

    }
}

const mapDispatchToProps = {

}


export default connect(mapStateToProps, mapDispatchToProps)(NumberInput)